module.exports = __webpack_public_path__ + "img/black_casion_a001_title.03ed3802.png";